import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import cx from "classnames"
import { updateJobService, getSuggestedSurveyor } from "requesters/jobServiceRequester"
import { getBaseUrl } from "../../reducers";

const SelectSurveyorButton = ({
  btnClassName, disabled, rowData, setTargetId, reloadData, onChangeSurveyorFailed, hasLeaveConflict, hasConflictingAssignments, outsideWorkHours
}) => {
  const {
    attributes: {
      surveyor_name: surveyorName,
      surveyor_id: surveyorId,
      role_label: roleLabel,
      required_respond_eta_at: requiredRespondEtaAt,
      disable_required_respond_eta: disableRequiredRespondEta,
      surveyor_not_attend: surveyorNotAttend,
      job_service: {
        data: {
          id: jobServiceId,
        }
      }
    },
    id: assignmentId
  } = rowData
  const [showSelectSurveyorView, setShowSelectSurveyorView] = useState(false)
  const [suggestedSurveyors, setSuggestedSurveyors] = useState({ suggested: [], other: [] })
  const baseUrl = useSelector(getBaseUrl)
  const isSurveyorNotAttend = requiredRespondEtaAt && !disableRequiredRespondEta && surveyorNotAttend

  const fetchSuggestedSurveyorData = () => {
    getSuggestedSurveyor(baseUrl, jobServiceId)
    .then(res => {
      if (res.status === 200 && res.response?.suggested_surveyors) {
        setSuggestedSurveyors(res.response.suggested_surveyors)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
  }

  const onChangeSurveyor = async (e) => {
    const { response, error } = await updateJobService(baseUrl, jobServiceId, { drafted_primary_surveyor_id: e.target.value })
    if (response) {
      setTargetId(assignmentId)
      reloadData()
    }
    if (error) {
      onChangeSurveyorFailed()
    }
  }

  const formattedRoleLabel = () => (roleLabel !== "Primary Surveyor" ? <i>{`(${roleLabel})`}</i> : null)

  useEffect(() => {
    if (showSelectSurveyorView) {
      fetchSuggestedSurveyorData()
    }
  }, [showSelectSurveyorView])

  const isOutsideWorkHours = outsideWorkHours || false
  const hasWarning = hasLeaveConflict || hasConflictingAssignments || isOutsideWorkHours
  const surveyorNameStyle = hasWarning ? { color: "#ff8c00", fontWeight: "bold" } : {}
  const buttonStyle = hasWarning ? { color: "#ff8c00" } : {}

  return (
    <React.Fragment>
      <button
        style={{ minHeight: "50px", ...buttonStyle }}
        disabled={disabled}
        className={`btn ${btnClassName}`}
        type="button"
        onClick={() => setShowSelectSurveyorView(true)}>
        <div className="d-flex justify-content-between align-items-center">
          <span className="flex-auto" style={surveyorNameStyle}>{surveyorName}</span>
          { isSurveyorNotAttend && (
            <span className="ml-1" title="Surveyor not attend">
              <i className="bi bi-exclamation-triangle-fill" />
            </span>
          )}
          { hasLeaveConflict && (
            <span className="ml-1" title="Surveyor on leave during estimated booking hours">
              <i className="bi bi-exclamation-triangle-fill" style={{ color: "#ff8c00" }} />
            </span>
          )}
          { hasConflictingAssignments && (
            <span className="ml-1" title="Surveyor has conflicting assignments with other jobs">
              <i className="bi bi-exclamation-triangle-fill" style={{ color: "#ff8c00" }} />
            </span>
          )}
          { isOutsideWorkHours && (
            <span className="ml-1" title="Surveyor is assigned outside of work hours">
              <i className="bi bi-exclamation-triangle-fill" style={{ color: "#ff8c00" }} />
            </span>
          )}
        </div>
        <div>{formattedRoleLabel()}</div>
      </button>
      <div
        onMouseLeave={() => setShowSelectSurveyorView(false)}
        className={cx("dropdown-menu shadow-sm", { "show-modal": showSelectSurveyorView })}>
        <p className="small mb-2">Select surveyor</p>
        <select
          className="form-control"
          value={surveyorId || ""}
          onChange={e => {
            onChangeSurveyor(e)
            setShowSelectSurveyorView(false)
          }}>
          {
            suggestedSurveyors && Object.keys(suggestedSurveyors).map(group => {
              const groupName = group.toUpperCase()
              const options = suggestedSurveyors[group]

              return (
                <optgroup label={groupName} key={groupName}>
                  { options.map(o => <option key={`${o.value}-${o.label}`} value={o.value} disabled={o.disabled}>{o.label}</option>) }
                </optgroup>
              )
            })
          }
        </select>
      </div>
    </React.Fragment>
  )
}

export default SelectSurveyorButton